import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';

import { AuthRoutingModule } from './auth-routing.module';

import { AuthComponent } from './components/auth';
import { RecoveryPassComponent } from './components/recovery-pass';
import { SignInComponent } from './components/signin';
import { NewPasswordComponent } from './components/new-password';

@NgModule({
  declarations: [
    SignInComponent,
    AuthComponent,
    RecoveryPassComponent,
    NewPasswordComponent,
  ],
  imports: [
    CommonModule,
    AuthRoutingModule,

    ReactiveFormsModule,
    FormsModule,

    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatIconModule,
    MatRippleModule,
  ],
})
export class AuthModule {}
